/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { IncidenciaModelDto } from '../../models/incidencia-model-dto';

export interface IncidenciasControllerObtencionIncidencias$Params {
}

export function incidenciasControllerObtencionIncidencias(http: HttpClient, rootUrl: string, params?: IncidenciasControllerObtencionIncidencias$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<IncidenciaModelDto>>> {
  const rb = new RequestBuilder(rootUrl, incidenciasControllerObtencionIncidencias.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<IncidenciaModelDto>>;
    })
  );
}

incidenciasControllerObtencionIncidencias.PATH = '/api/incidencias/obtener-incidencias';
